import { render, staticRenderFns } from "./PerformanceExpress.vue?vue&type=template&id=4a068ef1&scoped=true"
import script from "./PerformanceExpress.vue?vue&type=script&lang=js"
export * from "./PerformanceExpress.vue?vue&type=script&lang=js"
import style0 from "./PerformanceExpress.vue?vue&type=style&index=0&id=4a068ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a068ef1",
  null
  
)

export default component.exports